<template>
    <CRow>
        <CCol>
            <CCard v-if="entity">
                <CCardHeader>
                    <strong>{{ entity.title }}</strong>
                </CCardHeader>

                <CCardBody>
                    <AssistantServiceTabLinks />

                    <div class="flex items-center mt-4">
                        <div class="w-1/4">
                            <CSelect
                                class="mb-0"
                                horizontal
                                :value.sync="selectedOptionId"
                                :options="filteredOptions"
                                placeholder="Выберите вариант..."
                            />
                        </div>

                        <CButton
                            :color="selectedOptionId ? 'primary' : 'secondary'"
                            :class="{ 'cursor-not-allowed': !selectedOptionId }"
                            class="ml-6"
                            @click="onAddOption(selectedOptionId)"
                        >Добавить</CButton
                        >
                    </div>

                    <Draggable
                        v-model="options"
                        tag="div"
                        class="mt-4">
                        <div
                            v-for="item in options"
                            :key="item.id"
                            class="flex items-center h-10 px-2 py-4 border-t border-gray-300"
                        >
                            <div class="w-1/4">
                                <CIcon
                                    :height="24"
                                    :content="cilCursorMove"
                                    class="handle" />
                            </div>

                            <div class="w-2/4">{{ item.title }}</div>

                            <div class="w-1/4">
                                <CButton @click="removeOption(item.id)">
                                    <CIcon
                                        :height="12"
                                        :content="cilTrash"
                                        class="handle" />
                                </CButton>
                            </div>
                        </div>
                    </Draggable>
                </CCardBody>

                <CCardFooter>
                    <CButton color="primary" @click.prevent="submit">Сохранить</CButton>
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import to from 'await-to-js';
    import Draggable from 'vuedraggable';
    import { cilCursorMove, cilTrash } from '@coreui/icons';

    import AssistantServiceTabLinks from '@/components/assistant/AssistantServiceTabLinks';

    export default {
        components: {
            Draggable,
            AssistantServiceTabLinks,
        },

        data: () => ({
            cilCursorMove,
            cilTrash,
            entity: undefined,
            selectedOptionId: null,
            options: [],
            allOptions: [],
        }),

        computed: {
            filteredOptions() {
                if (Array.isArray(this.options)) {
                    const optionsIdList = this.options.map(item => item.id);
                    return this.allOptions.filter(
                        item => !optionsIdList.includes(item.id)
                    );
                }

                return this.allOptions;
            },
        },

        async created() {
            await Promise.all([this.fetchEntity(), this.fetchOptions()]);
        },

        methods: {
            async fetchEntity() {
                const { id, service_id } = this.$route.params;

                const [error, result] = await to(
                    this.axios.get(`/assistants/${id}/services/${service_id}`)
                );

                if (error) {
                    return this.$root.$emit('showError', 'Ошибка при получении услуги. ' + error);
                }

                this.entity = result.data;

                this.options = result.data.options.map(item => ({
                    ...item,
                    label: item.title,
                    value: item.id,
                }));
            },

            async fetchOptions() {
                const { id } = this.$route.params;
                const [error, result] = await to(
                    this.axios.get(`/assistants/${id}/options`)
                );

                if (error) {
                    return this.$root.$emit('showError', 'Ошибка при получении вариантов. ' + error);
                }

                this.allOptions = result.data.map(item => ({
                    ...item,
                    label: item.title,
                    value: item.id,
                }));
            },

            async submit() {
                const { id, service_id } = this.$route.params;

                const options = this.options.map((item, idx) => ({
                    id: item.id,
                    position: idx + 1,
                }));

                const [error] = await to(
                    this.axios.post(`/assistants/${id}/services/${service_id}/options`, {
                        options,
                    })
                );

                if (error) {
                    return this.$root.$emit('showError', 'Ошибка при сохранении вариантов. ' + error);
                } else {
                    this.$router.push(`/assistants/${id}/service/${service_id}`);
                }
            },

            onAddOption(id) {
                if (!id) {
                    return false;
                }

                const option = this.filteredOptions.find(item => item.id === id);

                if (option) {
                    this.options.push({
                        id: option.id,
                        title: option.title,
                    });
                    this.selectedOptionId = null;
                }
            },

            removeOption(id) {
                const idx = this.options.findIndex(item => item.id === id);

                if (idx === -1) {
                    return false;
                }

                this.options.splice(idx, 1);
            },
        },
    };
</script>
